<div class="breadcrumbs">
	<ul *ngIf="breadcrumbs">
		<li *ngFor="let bc of breadcrumbs" (click)="selectCategory(bc)">
			<span>{{bc.mediaCategoryDesc}}</span>
		</li>
	</ul>
</div>